// ref: https://gist.github.com/anubhavshrimal/75f6183458db8c453306f93521e93d37
export const COUNTRIES = [
  {
    name: "United States",
    dial_code: "+1",
    emoji: "🇺🇸",
    code: "US",
    timezone: "America/New_York",
  },
  {
    name: "Canada",
    dial_code: "+1",
    emoji: "🇨🇦",
    code: "CA",
    timezone: "America/Toronto",
  },
  {
    name: "Bahamas",
    dial_code: "+1242",
    emoji: "🇧🇸",
    code: "BS",
    timezone: "America/Nassau",
  },

  {
    name: "Barbados",
    dial_code: "+1246",
    emoji: "🇧🇧",
    code: "BB",
    timezone: "America/Barbados",
  },
  {
    name: "Anguilla",
    dial_code: "+1264",
    emoji: "🇦🇮",
    code: "AI",
    timezone: "America/Anguilla",
  },
  {
    name: "Antigua and Barbuda",
    dial_code: "+1268",
    emoji: "🇦🇬",
    code: "AG",
    timezone: "America/Antigua",
  },
  {
    name: "Virgin Islands, British",
    dial_code: "+1284",
    emoji: "🇻🇬",
    code: "VG",
    timezone: "America/Tortola",
  },
  {
    name: "Virgin Islands, U.S.",
    dial_code: "+1340",
    emoji: "🇻🇮",
    code: "VI",
    timezone: "America/St_Thomas",
  },
  {
    name: "Bermuda",
    dial_code: "+1441",
    emoji: "🇧🇲",
    code: "BM",
    timezone: "Atlantic/Bermuda",
  },

  {
    name: "Grenada",
    dial_code: "+1473",
    emoji: "🇬🇩",
    code: "GD",
    timezone: "America/Grenada",
  },

  {
    name: "Turks and Caicos Islands",
    dial_code: "+1649",
    emoji: "🇹🇨",
    code: "TC",
    timezone: "America/Grand_Turk",
  },
  {
    name: "Montserrat",
    dial_code: "+1664",
    emoji: "🇲🇸",
    code: "MS",
    timezone: "America/Montserrat",
  },
  {
    name: "Northern Mariana Islands",
    dial_code: "+1670",
    emoji: "🇲🇵",
    code: "MP",
    timezone: "Pacific/Saipan",
  },
  {
    name: "Guam",
    dial_code: "+1671",
    emoji: "🇬🇺",
    code: "GU",
    timezone: "Pacific/Guam",
  },

  {
    name: "AmericanSamoa",
    dial_code: "+1684",
    emoji: "🇦🇸",
    code: "AS",
    timezone: "Pacific/Pago_Pago",
  },

  {
    name: "Saint Lucia",
    dial_code: "+1758",
    emoji: "🇱🇨",
    code: "LC",
    timezone: "America/St_Lucia",
  },
  {
    name: "Dominica",
    dial_code: "+1767",
    emoji: "🇩🇲",
    code: "DM",
    timezone: "America/Dominica",
  },
  {
    name: "Saint Vincent and the Grenadines",
    dial_code: "+1784",
    emoji: "🇻🇨",
    code: "VC",
    timezone: "America/St_Vincent",
  },
  {
    name: "Dominican Republic",
    dial_code: "+1849",
    emoji: "🇩🇴",
    code: "DO",
    timezone: "America/Santo_Domingo",
  },
  {
    name: "Trinidad and Tobago",
    dial_code: "+1868",
    emoji: "🇹🇹",
    code: "TT",
    timezone: "America/Port_of_Spain",
  },

  {
    name: "Saint Kitts and Nevis",
    dial_code: "+1869",
    emoji: "🇰🇳",
    code: "KN",
    timezone: "America/St_Kitts",
  },
  {
    name: "Jamaica",
    dial_code: "+1876",
    emoji: "🇯🇲",
    code: "JM",
    timezone: "America/Jamaica",
  },
  {
    name: "Puerto Rico",
    dial_code: "+1939",
    emoji: "🇵🇷",
    code: "PR",
    timezone: "America/Puerto_Rico",
  },
  {
    name: "Algeria",
    dial_code: "+213",
    emoji: "🇩🇿",
    code: "DZ",
    timezone: "Africa/Algiers",
  },
  {
    name: "Angola",
    dial_code: "+244",
    emoji: "🇦🇴",
    code: "AO",
    timezone: "Africa/Luanda",
  },
  {
    name: "Aruba",
    dial_code: "+297",
    emoji: "🇦🇼",
    code: "AW",
    timezone: "America/Aruba",
  },
  {
    name: "Benin",
    dial_code: "+229",
    emoji: "🇧🇯",
    code: "BJ",
    timezone: "Africa/Porto-Novo",
  },
  {
    name: "Botswana",
    dial_code: "+267",
    emoji: "🇧🇼",
    code: "BW",
    timezone: "Africa/Gaborone",
  },
  {
    name: "British Indian Ocean Territory",
    dial_code: "+246",
    emoji: "🇮🇴",
    code: "IO",
    timezone: "Indian/Chagos",
  },
  {
    name: "Burkina Faso",
    dial_code: "+226",
    emoji: "🇧🇫",
    code: "BF",
    timezone: "Africa/Ouagadougou",
  },
  {
    name: "Burundi",
    dial_code: "+257",
    emoji: "🇧🇮",
    code: "BI",
    timezone: "Africa/Bujumbura",
  },
  {
    name: "Cameroon",
    dial_code: "+237",
    emoji: "🇨🇲",
    code: "CM",
    timezone: "Africa/Douala",
  },
  {
    name: "Cape Verde",
    dial_code: "+238",
    emoji: "🇨🇻",
    code: "CV",
    timezone: "Atlantic/Cape_Verde",
  },
  {
    name: "Central African Republic",
    dial_code: "+236",
    emoji: "🇨🇫",
    code: "CF",
    timezone: "Africa/Bangui",
  },
  {
    name: "Chad",
    dial_code: "+235",
    emoji: "🇹🇩",
    code: "TD",
    timezone: "Africa/Ndjamena",
  },
  {
    name: "Comoros",
    dial_code: "+269",
    emoji: "🇰🇲",
    code: "KM",
    timezone: "Indian/Comoro",
  },
  {
    name: "Congo",
    dial_code: "+242",
    emoji: "🇨🇬",
    code: "CG",
    timezone: "Africa/Brazzaville",
  },
  {
    name: "Congo, The Democratic Republic of the Congo",
    dial_code: "+243",
    emoji: "🇨🇩",
    code: "CD",
    timezone: "Africa/Kinshasa",
  },
  {
    name: "Cote d'Ivoire",
    dial_code: "+225",
    emoji: "🇨🇮",
    code: "CI",
    timezone: "Africa/Abidjan",
  },
  {
    name: "Djibouti",
    dial_code: "+253",
    emoji: "🇩🇯",
    code: "DJ",
    timezone: "Africa/Djibouti",
  },
  {
    name: "Egypt",
    dial_code: "+20",
    emoji: "🇪🇬",
    code: "EG",
    timezone: "Africa/Cairo",
  },
  {
    name: "Equatorial Guinea",
    dial_code: "+240",
    emoji: "🇬🇶",
    code: "GQ",
    timezone: "Africa/Malabo",
  },
  {
    name: "Eritrea",
    dial_code: "+291",
    emoji: "🇪🇷",
    code: "ER",
    timezone: "Africa/Asmara",
  },
  {
    name: "Ethiopia",
    dial_code: "+251",
    emoji: "🇪🇹",
    code: "ET",
    timezone: "Africa/Addis_Ababa",
  },
  {
    name: "Faroe Islands",
    dial_code: "+298",
    emoji: "🇫🇴",
    code: "FO",
    timezone: "Atlantic/Faroe",
  },
  {
    name: "Gabon",
    dial_code: "+241",
    emoji: "🇬🇦",
    code: "GA",
    timezone: "Africa/Libreville",
  },
  {
    name: "Gambia",
    dial_code: "+220",
    emoji: "🇬🇲",
    code: "GM",
    timezone: "Africa/Banjul",
  },
  {
    name: "Ghana",
    dial_code: "+233",
    emoji: "🇬🇭",
    code: "GH",
    timezone: "Africa/Accra",
  },
  {
    name: "Greenland",
    dial_code: "+299",
    emoji: "🇬🇱",
    code: "GL",
    timezone: "America/Godthab",
  },
  {
    name: "Guinea",
    dial_code: "+224",
    emoji: "🇬🇳",
    code: "GN",
    timezone: "Africa/Conakry",
  },
  {
    name: "Guinea-Bissau",
    dial_code: "+245",
    emoji: "🇬🇼",
    code: "GW",
    timezone: "Africa/Bissau",
  },
  {
    name: "Kenya",
    dial_code: "+254",
    emoji: "🇰🇪",
    code: "KE",
    timezone: "Africa/Nairobi",
  },
  {
    name: "Lesotho",
    dial_code: "+266",
    emoji: "🇱🇸",
    code: "LS",
    timezone: "Africa/Maseru",
  },
  {
    name: "Liberia",
    dial_code: "+231",
    emoji: "🇱🇷",
    code: "LR",
    timezone: "Africa/Monrovia",
  },
  {
    name: "Libyan Arab Jamahiriya",
    dial_code: "+218",
    emoji: "🇱🇾",
    code: "LY",
    timezone: "Africa/Tripoli",
  },
  {
    name: "Madagascar",
    dial_code: "+261",
    emoji: "🇲🇬",
    code: "MG",
    timezone: "Indian/Antananarivo",
  },
  {
    name: "Malawi",
    dial_code: "+265",
    emoji: "🇲🇼",
    code: "MW",
    timezone: "Africa/Blantyre",
  },
  {
    name: "Mali",
    dial_code: "+223",
    emoji: "🇲🇱",
    code: "ML",
    timezone: "Africa/Bamako",
  },
  {
    name: "Mauritania",
    dial_code: "+222",
    emoji: "🇲🇷",
    code: "MR",
    timezone: "Africa/Nouakchott",
  },
  {
    name: "Mauritius",
    dial_code: "+230",
    emoji: "🇲🇺",
    code: "MU",
    timezone: "Indian/Mauritius",
  },
  {
    name: "Mayotte",
    dial_code: "+262",
    emoji: "🇾🇹",
    code: "YT",
    timezone: "Indian/Mayotte",
  },
  {
    name: "Morocco",
    dial_code: "+212",
    emoji: "🇲🇦",
    code: "MA",
    timezone: "Africa/Casablanca",
  },
  {
    name: "Mozambique",
    dial_code: "+258",
    emoji: "🇲🇿",
    code: "MZ",
    timezone: "Africa/Maputo",
  },
  {
    name: "Namibia",
    emoji: "🇳🇦",
    dial_code: "+264",
    code: "NA",
    timezone: "Africa/Windhoek",
  },
  {
    name: "Niger",
    dial_code: "+227",
    emoji: "🇳🇪",
    code: "NE",
    timezone: "Africa/Niamey",
  },
  {
    name: "Nigeria",
    dial_code: "+234",
    emoji: "🇳🇬",
    code: "NG",
    timezone: "Africa/Lagos",
  },
  {
    name: "Rwanda",
    dial_code: "+250",
    emoji: "🇷🇼",
    code: "RW",
    timezone: "Africa/Kigali",
  },
  {
    name: "Reunion",
    dial_code: "+262",
    emoji: "🇷🇪",
    code: "RE",
    timezone: "Indian/Reunion",
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    dial_code: "+290",
    emoji: "🇸🇭",
    code: "SH",
    timezone: "Atlantic/St_Helena",
  },
  {
    name: "Sao Tome and Principe",
    dial_code: "+239",
    emoji: "🇸🇹",
    code: "ST",
    timezone: "Africa/Sao_Tome",
  },
  {
    name: "Senegal",
    dial_code: "+221",
    emoji: "🇸🇳",
    code: "SN",
    timezone: "Africa/Dakar",
  },
  {
    name: "Seychelles",
    dial_code: "+248",
    emoji: "🇸🇨",
    code: "SC",
    timezone: "Indian/Mahe",
  },
  {
    name: "Sierra Leone",
    dial_code: "+232",
    emoji: "🇸🇱",
    code: "SL",
    timezone: "Africa/Freetown",
  },
  {
    name: "Somalia",
    dial_code: "+252",
    emoji: "🇸🇴",
    code: "SO",
    timezone: "Africa/Mogadishu",
  },
  {
    name: "South Africa",
    dial_code: "+27",
    emoji: "🇿🇦",
    code: "ZA",
    timezone: "Africa/Johannesburg",
  },
  {
    name: "South Sudan",
    dial_code: "+211",
    emoji: "🇸🇸",
    code: "SS",
    timezone: "Africa/Juba",
  },
  {
    name: "Sudan",
    dial_code: "+249",
    emoji: "🇸🇩",
    code: "SD",
    timezone: "Africa/Khartoum",
  },
  {
    name: "Swaziland",
    dial_code: "+268",
    emoji: "🇸🇿",
    code: "SZ",
    timezone: "Africa/Mbabane",
  },
  {
    name: "Tanzania, United Republic of Tanzania",
    dial_code: "+255",
    emoji: "🇹🇿",
    code: "TZ",
    timezone: "Africa/Dar_es_Salaam",
  },
  {
    name: "Togo",
    dial_code: "+228",
    emoji: "🇹🇬",
    code: "TG",
    timezone: "Africa/Lome",
  },
  {
    name: "Tunisia",
    dial_code: "+216",
    emoji: "🇹🇳",
    code: "TN",
    timezone: "Africa/Tunis",
  },
  {
    name: "Uganda",
    dial_code: "+256",
    emoji: "🇺🇬",
    code: "UG",
    timezone: "Africa/Kampala",
  },
  {
    name: "Zambia",
    dial_code: "+260",
    emoji: "🇿🇲",
    code: "ZM",
    timezone: "Africa/Lusaka",
  },
  {
    name: "Zimbabwe",
    dial_code: "+263",
    emoji: "🇿🇼",
    code: "ZW",
    timezone: "Africa/Harare",
  },
  {
    name: "Aland Islands",
    dial_code: "+358",
    emoji: "🇦🇽",
    code: "AX",
    timezone: "Europe/Mariehamn",
  },
  {
    name: "Albania",
    dial_code: "+355",
    emoji: "🇦🇱",
    code: "AL",
    timezone: "Europe/Tirane",
  },
  {
    name: "Andorra",
    dial_code: "+376",
    emoji: "🇦🇩",
    code: "AD",
    timezone: "Europe/Andorra",
  },
  {
    name: "Armenia",
    dial_code: "+374",
    emoji: "🇦🇲",
    code: "AM",
    timezone: "Asia/Yerevan",
  },
  {
    name: "Belarus",
    dial_code: "+375",
    emoji: "🇧🇾",
    code: "BY",
    timezone: "Europe/Minsk",
  },
  {
    name: "Belgium",
    dial_code: "+32",
    emoji: "🇧🇪",
    code: "BE",
    timezone: "Europe/Brussels",
  },
  {
    name: "Bosnia and Herzegovina",
    dial_code: "+387",
    emoji: "🇧🇦",
    code: "BA",
    timezone: "Europe/Sarajevo",
  },
  {
    name: "Bulgaria",
    dial_code: "+359",
    emoji: "🇧🇬",
    code: "BG",
    timezone: "Europe/Sofia",
  },
  {
    name: "Cayman Islands",
    dial_code: "+345",
    emoji: "🇰🇾",
    code: "KY",
    timezone: "America/Cayman",
  },
  {
    name: "Croatia",
    dial_code: "+385",
    emoji: "🇭🇷",
    code: "HR",
    timezone: "Europe/Zagreb",
  },
  {
    name: "Cyprus",
    dial_code: "+357",
    emoji: "🇨🇾",
    code: "CY",
    timezone: "Asia/Nicosia",
  },
  {
    name: "Estonia",
    dial_code: "+372",
    emoji: "🇪🇪",
    code: "EE",
    timezone: "Europe/Tallinn",
  },
  {
    name: "Finland",
    dial_code: "+358",
    emoji: "🇫🇮",
    code: "FI",
    timezone: "Europe/Helsinki",
  },
  {
    name: "France",
    dial_code: "+33",
    emoji: "🇫🇷",
    code: "FR",
    timezone: "Europe/Paris",
  },
  {
    name: "Gibraltar",
    dial_code: "+350",
    emoji: "🇬🇮",
    code: "GI",
    timezone: "Europe/Gibraltar",
  },
  {
    name: "Greece",
    dial_code: "+30",
    emoji: "🇬🇷",
    code: "GR",
    timezone: "Europe/Athens",
  },
  {
    name: "Holy See (Vatican City State)",
    dial_code: "+379",
    emoji: "🇻🇦",
    code: "VA",
    timezone: "Europe/Vatican",
  },
  {
    name: "Hungary",
    dial_code: "+36",
    emoji: "🇭🇺",
    code: "HU",
    timezone: "Europe/Budapest",
  },
  {
    name: "Iceland",
    dial_code: "+354",
    emoji: "🇮🇸",
    code: "IS",
    timezone: "Atlantic/Reykjavik",
  },
  {
    name: "Ireland",
    dial_code: "+353",
    emoji: "🇮🇪",
    code: "IE",
    timezone: "Europe/Dublin",
  },
  {
    name: "Italy",
    dial_code: "+39",
    emoji: "🇮🇹",
    code: "IT",
    timezone: "Europe/Rome",
  },
  {
    name: "Latvia",
    dial_code: "+371",
    emoji: "🇱🇻",
    code: "LV",
    timezone: "Europe/Riga",
  },
  {
    name: "Lithuania",
    dial_code: "+370",
    emoji: "🇱🇹",
    code: "LT",
    timezone: "Europe/Vilnius",
  },
  {
    name: "Luxembourg",
    dial_code: "+352",
    emoji: "🇱🇺",
    code: "LU",
    timezone: "Europe/Luxembourg",
  },
  {
    name: "Macedonia",
    dial_code: "+389",
    emoji: "🇲🇰",
    code: "MK",
    timezone: "Europe/Skopje",
  },
  {
    name: "Malta",
    dial_code: "+356",
    emoji: "🇲🇹",
    code: "MT",
    timezone: "Europe/Malta",
  },
  {
    name: "Moldova",
    dial_code: "+373",
    emoji: "🇲🇩",
    code: "MD",
    timezone: "Europe/Chisinau",
  },
  {
    name: "Monaco",
    dial_code: "+377",
    emoji: "🇲🇨",
    code: "MC",
    timezone: "Europe/Monaco",
  },
  {
    name: "Montenegro",
    dial_code: "+382",
    emoji: "🇲🇪",
    code: "ME",
    timezone: "Europe/Podgorica",
  },
  {
    name: "Netherlands",
    dial_code: "+31",
    emoji: "🇳🇱",
    code: "NL",
    timezone: "Europe/Amsterdam",
  },
  {
    name: "Portugal",
    dial_code: "+351",
    emoji: "🇵🇹",
    code: "PT",
    timezone: "Europe/Lisbon",
  },
  {
    name: "San Marino",
    dial_code: "+378",
    emoji: "🇸🇲",
    code: "SM",
    timezone: "Europe/San_Marino",
  },
  {
    name: "Serbia",
    dial_code: "+381",
    emoji: "🇷🇸",
    code: "RS",
    timezone: "Europe/Belgrade",
  },
  {
    name: "Slovenia",
    dial_code: "+386",
    emoji: "🇸🇮",
    code: "SI",
    timezone: "Europe/Ljubljana",
  },
  {
    name: "Spain",
    dial_code: "+34",
    emoji: "🇪🇸",
    code: "ES",
    timezone: "Europe/Madrid",
  },
  {
    name: "Ukraine",
    dial_code: "+380",
    emoji: "🇺🇦",
    code: "UA",
    timezone: "Europe/Kiev",
  },
  {
    name: "Austria",
    dial_code: "+43",
    emoji: "🇦🇹",
    code: "AT",
    timezone: "Europe/Vienna",
  },
  {
    name: "Czech Republic",
    dial_code: "+420",
    emoji: "🇨🇿",
    code: "CZ",
    timezone: "Europe/Prague",
  },
  {
    name: "Denmark",
    dial_code: "+45",
    emoji: "🇩🇰",
    code: "DK",
    timezone: "Europe/Copenhagen",
  },
  {
    name: "Germany",
    dial_code: "+49",
    emoji: "🇩🇪",
    code: "DE",
    timezone: "Europe/Berlin",
  },
  {
    name: "Guernsey",
    dial_code: "+44",
    emoji: "🇬🇬",
    code: "GG",
    timezone: "Europe/Guernsey",
  },
  {
    name: "Isle of Man",
    dial_code: "+44",
    emoji: "🇮🇲",
    code: "IM",
    timezone: "Europe/Isle_of_Man",
  },
  {
    name: "Jersey",
    dial_code: "+44",
    emoji: "🇯🇪",
    code: "JE",
    timezone: "Europe/Jersey",
  },
  {
    name: "Liechtenstein",
    dial_code: "+423",
    emoji: "🇱🇮",
    code: "LI",
    timezone: "Europe/Vaduz",
  },
  {
    name: "Norway",
    dial_code: "+47",
    emoji: "🇳🇴",
    code: "NO",
    timezone: "Europe/Oslo",
  },
  {
    name: "Poland",
    dial_code: "+48",
    emoji: "🇵🇱",
    code: "PL",
    timezone: "Europe/Warsaw",
  },
  {
    name: "Romania",
    dial_code: "+40",
    emoji: "🇷🇴",
    code: "RO",
    timezone: "Europe/Bucharest",
  },
  {
    name: "Slovakia",
    dial_code: "+421",
    emoji: "🇸🇰",
    code: "SK",
    timezone: "Europe/Bratislava",
  },
  {
    name: "Svalbard and Jan Mayen",
    dial_code: "+47",
    emoji: "🇸🇯",
    code: "SJ",
    timezone: "Arctic/Longyearbyen",
  },
  {
    name: "Sweden",
    dial_code: "+46",
    emoji: "🇸🇪",
    code: "SE",
    timezone: "Europe/Stockholm",
  },
  {
    name: "Switzerland",
    dial_code: "+41",
    emoji: "🇨🇭",
    code: "CH",
    timezone: "Europe/Zurich",
  },
  {
    name: "United Kingdom",
    dial_code: "+44",
    emoji: "🇬🇧",
    code: "GB",
    timezone: "Europe/London",
  },
  {
    name: "Argentina",
    dial_code: "+54",
    emoji: "🇦🇷",
    code: "AR",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    name: "Belize",
    dial_code: "+501",
    emoji: "🇧🇿",
    code: "BZ",
    timezone: "America/Belize",
  },
  {
    name: "Bolivia, Plurinational State of",
    dial_code: "+591",
    emoji: "🇧🇴",
    code: "BO",
    timezone: "America/La_Paz",
  },
  {
    name: "Brazil",
    dial_code: "+55",
    emoji: "🇧🇷",
    code: "BR",
    timezone: "America/Sao_Paulo",
  },
  {
    name: "Chile",
    dial_code: "+56",
    emoji: "🇨🇱",
    code: "CL",
    timezone: "America/Santiago",
  },
  {
    name: "Colombia",
    dial_code: "+57",
    emoji: "🇨🇴",
    code: "CO",
    timezone: "America/Bogota",
  },
  {
    name: "Costa Rica",
    dial_code: "+506",
    emoji: "🇨🇷",
    code: "CR",
    timezone: "America/Costa_Rica",
  },
  {
    name: "Cuba",
    dial_code: "+53",
    emoji: "🇨🇺",
    code: "CU",
    timezone: "America/Havana",
  },
  {
    name: "Ecuador",
    dial_code: "+593",
    emoji: "🇪🇨",
    code: "EC",
    timezone: "America/Guayaquil",
  },
  {
    name: "El Salvador",
    dial_code: "+503",
    emoji: "🇸🇻",
    code: "SV",
    timezone: "America/El_Salvador",
  },
  {
    name: "Falkland Islands (Malvinas)",
    dial_code: "+500",
    emoji: "🇫🇰",
    code: "FK",
    timezone: "Atlantic/Stanley",
  },
  {
    name: "French Guiana",
    dial_code: "+594",
    emoji: "🇬🇫",
    code: "GF",
    timezone: "America/Cayenne",
  },
  {
    name: "Guadeloupe",
    dial_code: "+590",
    emoji: "🇬🇵",
    code: "GP",
    timezone: "America/Guadeloupe",
  },
  {
    name: "Guatemala",
    dial_code: "+502",
    emoji: "🇬🇹",
    code: "GT",
    timezone: "America/Guatemala",
  },
  {
    name: "Guyana",
    dial_code: "+595",
    emoji: "🇬🇾",
    code: "GY",
    timezone: "America/Guyana",
  },
  {
    name: "Haiti",
    dial_code: "+509",
    emoji: "🇭🇹",
    code: "HT",
    timezone: "America/Port-au-Prince",
  },
  {
    name: "Honduras",
    dial_code: "+504",
    emoji: "🇭🇳",
    code: "HN",
    timezone: "America/Tegucigalpa",
  },
  {
    name: "Martinique",
    dial_code: "+596",
    emoji: "🇲🇶",
    code: "MQ",
    timezone: "America/Martinique",
  },
  {
    name: "Mexico",
    dial_code: "+52",
    emoji: "🇲🇽",
    code: "MX",
    timezone: "America/Mexico_City",
  },
  {
    name: "Netherlands Antilles",
    dial_code: "+599",
    emoji: "🇧🇶",
    code: "AN",
    timezone: "America/Curacao",
  },
  {
    name: "Nicaragua",
    dial_code: "+505",
    emoji: "🇳🇮",
    code: "NI",
    timezone: "America/Managua",
  },
  {
    name: "Panama",
    dial_code: "+507",
    emoji: "🇵🇦",
    code: "PA",
    timezone: "America/Panama",
  },
  {
    name: "Paraguay",
    dial_code: "+595",
    emoji: "🇵🇾",
    code: "PY",
    timezone: "America/Asuncion",
  },
  {
    name: "Peru",
    dial_code: "+51",
    emoji: "🇵🇪",
    code: "PE",
    timezone: "America/Lima",
  },
  {
    name: "Saint Barthelemy",
    dial_code: "+590",
    emoji: "🇧🇱",
    code: "BL",
    timezone: "America/St_Barthelemy",
  },
  {
    name: "Saint Martin",
    dial_code: "+590",
    emoji: "🇲🇫",
    code: "MF",
    timezone: "America/Marigot",
  },
  {
    name: "Saint Pierre and Miquelon",
    dial_code: "+508",
    emoji: "🇵🇲",
    code: "PM",
    timezone: "America/Miquelon",
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    dial_code: "+500",
    emoji: "🇬🇸",
    code: "GS",
    timezone: "Atlantic/South_Georgia",
  },
  {
    name: "Suriname",
    dial_code: "+597",
    emoji: "🇸🇷",
    code: "SR",
    timezone: "America/Paramaribo",
  },
  {
    name: "Uruguay",
    dial_code: "+598",
    emoji: "🇺🇾",
    code: "UY",
    timezone: "America/Montevideo",
  },
  {
    name: "Venezuela, Bolivarian Republic of Venezuela",
    dial_code: "+58",
    emoji: "🇻🇪",
    code: "VE",
    timezone: "America/Caracas",
  },
  {
    name: "Antarctica",
    dial_code: "+672",
    emoji: "🇦🇶",
    code: "AQ",
    timezone: "Antarctica/McMurdo",
  },
  {
    name: "Australia",
    dial_code: "+61",
    emoji: "🇦🇺",
    code: "AU",
    timezone: "Australia/Sydney",
  },
  {
    name: "Brunei Darussalam",
    dial_code: "+673",
    emoji: "🇧🇳",
    code: "BN",
    timezone: "Asia/Brunei",
  },
  {
    name: "Christmas Island",
    dial_code: "+61",
    emoji: "🇨🇽",
    code: "CX",
    timezone: "Indian/Christmas",
  },
  {
    name: "Cocos (Keeling) Islands",
    dial_code: "+61",
    emoji: "🇨🇨",
    code: "CC",
    timezone: "Indian/Cocos",
  },
  {
    name: "Cook Islands",
    dial_code: "+682",
    emoji: "🇨🇰",
    code: "CK",
    timezone: "Pacific/Rarotonga",
  },
  {
    name: "Fiji",
    dial_code: "+679",
    emoji: "🇫🇯",
    code: "FJ",
    timezone: "Pacific/Fiji",
  },
  {
    name: "French Polynesia",
    dial_code: "+689",
    emoji: "🇵🇫",
    code: "PF",
    timezone: "Pacific/Tahiti",
  },
  {
    name: "Indonesia",
    dial_code: "+62",
    emoji: "🇮🇩",
    code: "ID",
    timezone: "Asia/Jakarta",
  },
  {
    name: "Kiribati",
    dial_code: "+686",
    emoji: "🇰🇮",
    code: "KI",
    timezone: "Pacific/Tarawa",
  },
  {
    name: "Malaysia",
    dial_code: "+60",
    emoji: "🇲🇾",
    code: "MY",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    name: "Marshall Islands",
    dial_code: "+692",
    emoji: "🇲🇭",
    code: "MH",
    timezone: "Pacific/Majuro",
  },
  {
    name: "Micronesia, Federated States of Micronesia",
    dial_code: "+691",
    emoji: "🇫🇲",
    code: "FM",
    timezone: "Pacific/Chuuk",
  },
  {
    name: "Nauru",
    dial_code: "+674",
    emoji: "🇳🇷",
    code: "NR",
    timezone: "Pacific/Nauru",
  },
  {
    name: "New Caledonia",
    dial_code: "+687",
    emoji: "🇳🇨",
    code: "NC",
    timezone: "Pacific/Noumea",
  },
  {
    name: "New Zealand",
    dial_code: "+64",
    emoji: "🇳🇿",
    code: "NZ",
    timezone: "Pacific/Auckland",
  },
  {
    name: "Niue",
    dial_code: "+683",
    emoji: "🇳🇺",
    code: "NU",
    timezone: "Pacific/Niue",
  },
  {
    name: "Norfolk Island",
    dial_code: "+672",
    emoji: "🇳🇫",
    code: "NF",
    timezone: "Pacific/Norfolk",
  },
  {
    name: "Palau",
    dial_code: "+680",
    emoji: "🇵🇼",
    code: "PW",
    timezone: "Pacific/Palau",
  },
  {
    name: "Papua New Guinea",
    dial_code: "+675",
    emoji: "🇵🇬",
    code: "PG",
    timezone: "Pacific/Port_Moresby",
  },
  {
    name: "Philippines",
    dial_code: "+63",
    emoji: "🇵🇭",
    code: "PH",
    timezone: "Asia/Manila",
  },
  {
    name: "Samoa",
    dial_code: "+685",
    emoji: "🇼🇸",
    code: "WS",
    timezone: "Pacific/Apia",
  },
  {
    name: "Singapore",
    dial_code: "+65",
    emoji: "🇸🇬",
    code: "SG",
    timezone: "Asia/Singapore",
  },
  {
    name: "Solomon Islands",
    dial_code: "+677",
    emoji: "🇸🇧",
    code: "SB",
    timezone: "Pacific/Guadalcanal",
  },
  {
    name: "Thailand",
    dial_code: "+66",
    emoji: "🇹🇭",
    code: "TH",
    timezone: "Asia/Bangkok",
  },
  {
    name: "Timor-Leste",
    dial_code: "+670",
    emoji: "🇹🇱",
    code: "TL",
    timezone: "Asia/Dili",
  },
  {
    name: "Tokelau",
    dial_code: "+690",
    emoji: "🇹🇰",
    code: "TK",
    timezone: "Pacific/Fakaofo",
  },
  {
    name: "Tonga",
    dial_code: "+676",
    emoji: "🇹🇴",
    code: "TO",
    timezone: "Pacific/Tongatapu",
  },
  {
    name: "Tuvalu",
    dial_code: "+688",
    emoji: "🇹🇻",
    code: "TV",
    timezone: "Pacific/Funafuti",
  },
  {
    name: "Vanuatu",
    dial_code: "+678",
    emoji: "🇻🇺",
    code: "VU",
    timezone: "Pacific/Efate",
  },
  {
    name: "Wallis and Futuna",
    dial_code: "+681",
    emoji: "🇼🇫",
    code: "WF",
    timezone: "Pacific/Wallis",
  },
  {
    name: "Kazakhstan",
    dial_code: "+77",
    emoji: "🇰🇿",
    code: "KZ",
    timezone: "Asia/Almaty",
  },
  {
    name: "Russia",
    dial_code: "+7",
    emoji: "🇷🇺",
    code: "RU",
    timezone: "Europe/Kaliningrad",
  },
  {
    name: "Bangladesh",
    dial_code: "+880",
    emoji: "🇧🇩",
    code: "BD",
    timezone: "Asia/Dhaka",
  },
  {
    name: "Cambodia",
    dial_code: "+855",
    emoji: "🇰🇭",
    code: "KH",
    timezone: "Asia/Phnom_Penh",
  },
  {
    name: "China",
    dial_code: "+86",
    emoji: "🇨🇳",
    code: "CN",
    timezone: "Asia/Shanghai",
  },
  {
    name: "Hong Kong",
    dial_code: "+852",
    emoji: "🇭🇰",
    code: "HK",
    timezone: "Asia/Hong_Kong",
  },
  {
    name: "Japan",
    dial_code: "+81",
    emoji: "🇯🇵",
    code: "JP",
    timezone: "Asia/Tokyo",
  },
  {
    name: "Korea, Republic of South Korea",
    dial_code: "+82",
    emoji: "🇰🇷",
    code: "KR",
    timezone: "Asia/Seoul",
  },
  {
    name: "Laos",
    dial_code: "+856",
    emoji: "🇱🇦",
    code: "LA",
    timezone: "Asia/Vientiane",
  },
  {
    name: "Macao",
    dial_code: "+853",
    emoji: "🇲🇴",
    code: "MO",
    timezone: "Asia/Macau",
  },
  {
    name: "Pitcairn",
    dial_code: "+872",
    emoji: "🇵🇳",
    code: "PN",
    timezone: "Pacific/Pitcairn",
  },
  {
    name: "Taiwan",
    dial_code: "+886",
    emoji: "🇹🇼",
    code: "TW",
    timezone: "Asia/Taipei",
  },
  {
    name: "Vietnam",
    dial_code: "+84",
    emoji: "🇻🇳",
    code: "VN",
    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    name: "Afghanistan",
    dial_code: "+93",
    emoji: "🇦🇫",
    code: "AF",
    timezone: "Asia/Kabul",
  },
  {
    name: "Azerbaijan",
    dial_code: "+994",
    emoji: "🇦🇿",
    code: "AZ",
    timezone: "Asia/Baku",
  },
  {
    name: "Bahrain",
    dial_code: "+973",
    emoji: "🇧🇭",
    code: "BH",
    timezone: "Asia/Bahrain",
  },
  {
    name: "Bhutan",
    dial_code: "+975",
    emoji: "🇧🇹",
    code: "BT",
    timezone: "Asia/Thimphu",
  },
  {
    name: "Georgia",
    dial_code: "+995",
    emoji: "🇬🇪",
    code: "GE",
    timezone: "Asia/Tbilisi",
  },
  {
    name: "India",
    dial_code: "+91",
    emoji: "🇮🇳",
    code: "IN",
    timezone: "Asia/Kolkata",
  },
  {
    name: "Iran, Islamic Republic of Persian Gulf",
    dial_code: "+98",
    emoji: "🇮🇷",
    code: "IR",
    timezone: "Asia/Tehran",
  },
  {
    name: "Iraq",
    dial_code: "+964",
    emoji: "🇮🇷",
    code: "IQ",
    timezone: "Asia/Baghdad",
  },
  {
    name: "Israel",
    dial_code: "+972",
    emoji: "🇮🇱",
    code: "IL",
    timezone: "Asia/Jerusalem",
  },
  {
    name: "Jordan",
    dial_code: "+962",
    emoji: "🇯🇴",
    code: "JO",
    timezone: "Asia/Amman",
  },
  {
    name: "Kuwait",
    dial_code: "+965",
    emoji: "🇰🇼",
    code: "KW",
    timezone: "Asia/Kuwait",
  },
  {
    name: "Kyrgyzstan",
    dial_code: "+996",
    emoji: "🇰🇬",
    code: "KG",
    timezone: "Asia/Bishkek",
  },
  {
    name: "Lebanon",
    dial_code: "+961",
    emoji: "🇱🇧",
    code: "LB",
    timezone: "Asia/Beirut",
  },
  {
    name: "Maldives",
    dial_code: "+960",
    emoji: "🇲🇻",
    code: "MV",
    timezone: "Indian/Maldives",
  },
  {
    name: "Mongolia",
    dial_code: "+976",
    emoji: "🇲🇳",
    code: "MN",
    timezone: "Asia/Ulaanbaatar",
  },
  {
    name: "Myanmar",
    dial_code: "+95",
    emoji: "🇲🇲",
    code: "MM",
    timezone: "Asia/Yangon",
  },
  {
    name: "Nepal",
    dial_code: "+977",
    emoji: "🇳🇵",
    code: "NP",
    timezone: "Asia/Kathmandu",
  },
  {
    name: "Oman",
    dial_code: "+968",
    emoji: "🇴🇲",
    code: "OM",
    timezone: "Asia/Muscat",
  },
  {
    name: "Pakistan",
    dial_code: "+92",
    emoji: "🇵🇰",
    code: "PK",
    timezone: "Asia/Karachi",
  },
  {
    name: "Palestinian Territory, Occupied",
    dial_code: "+970",
    emoji: "🇵🇸",
    code: "PS",
    timezone: "Asia/Hebron",
  },
  {
    name: "Qatar",
    dial_code: "+974",
    emoji: "🇶🇦",
    code: "QA",
    timezone: "Asia/Qatar",
  },
  {
    name: "Saudi Arabia",
    dial_code: "+966",
    emoji: "🇸🇦",
    code: "SA",
    timezone: "Asia/Riyadh",
  },
  {
    name: "Sri Lanka",
    dial_code: "+94",
    emoji: "🇱🇰",
    code: "LK",
    timezone: "Asia/Colombo",
  },
  {
    name: "Syrian Arab Republic",
    dial_code: "+963",
    emoji: "🇸🇾",
    code: "SY",
    timezone: "Asia/Damascus",
  },
  {
    name: "Tajikistan",
    dial_code: "+992",
    emoji: "🇹🇯",
    code: "TJ",
    timezone: "Asia/Dushanbe",
  },
  {
    name: "Turkey",
    dial_code: "+90",
    emoji: "🇹🇷",
    code: "TR",
    timezone: "Europe/Istanbul",
  },
  {
    name: "Turkmenistan",
    dial_code: "+993",
    emoji: "🇹🇲",
    code: "TM",
    timezone: "Asia/Ashgabat",
  },
  {
    name: "United Arab Emirates",
    dial_code: "+971",
    emoji: "🇦🇪",
    code: "AE",
    timezone: "Asia/Dubai",
  },
  {
    name: "Uzbekistan",
    dial_code: "+998",
    emoji: "🇺🇿",
    code: "UZ",
    timezone: "Asia/Samarkand",
  },
  {
    name: "Yemen",
    dial_code: "+967",
    emoji: "🇾🇪",
    code: "YE",
    timezone: "Asia/Aden",
  },
];

export const COUNTRY_MAP = new Map(
  COUNTRIES.map((country) => [
    country.code,
    {
      ...country,
      callingCode: `${country.dial_code.match(/^\+1\d+$/) ? `+1 ${country.dial_code.slice(2)}` : country.dial_code}`,
    },
  ]),
);
